module.exports = __webpack_public_path__ + "media/top/icon_tag-824a9900.svg";